/* ============
 * Supplier Index
 * ============
 *
 * This page shows the list of Bills.
 */
import moment from 'moment';
import { mapGetters, mapMutations } from 'vuex';
import unitOfMeasureService from './../../../../services/unitOfMeasure';
import debounce from 'debounce';
import SearchMixin from './../../../../mixins/search';

export default {
  data() {
    return {
      loading: true,
      sortValue: '',
    };
  },

  computed: {
    ...mapGetters({
      unitOfMeasures: 'paginateUnitOfMeasures',
    }),

    unitOfMeasuresList() {
      return this.unitOfMeasures.items.map((b) => {
       /* let cardClass = '';

        if (b.billStatus === 'Overdue') {
          cardClass = 'card-red';
        } else if (b.billStatus === 'Cleared') {
          cardClass = 'card-green';
        } else if (b.billStatus === 'Sent') {
          cardClass = 'card-yellow';
        }

        Object.assign(b, {
          number: b.billingNumber ? `#${b.billingNumber}` : 'Draft',
          value: `${b.totalValue.toFixed(2)} NOK`,
          amount: `(${b.totalQuantity} ${this.$t('static.bills.index.quantities')})`,
          dueDateFormated: moment(b.dueDate).isValid() ? moment(b.dueDate).format('DD-MM-YYYY') : '-',
          cardClass,
        });*/

        return b;
      });
    },
  },

  watch: {
    /**
     * Listem to router changes, used to check query params that have changed to apply filters.
     *
     * @param  {Object} route Current route object.
     */
    $route() {
      this.all(1, 50);
    },
  },

  components: {
    VCard: require('./../../../../components/card/card.vue'),
    VPagination: require('./../../../../components/paginationNew/paginationNew.vue'),
    VNoData: require('./../../../../components/noData/noData.vue'),
  },

  mixins: [
    SearchMixin,
  ],

  mounted() {
    this.setInnerSidebar([
      {
        title: this.$t('static.products.filters.title'),
        options: [
          {
            title: this.$t('static.products.filters.latest'),
            route: {
              name: 'products.index',
              query: {
                filter: 'latest',
              },
            },
          },
          {
            title: this.$t('static.products.filters.pastMonth'),
            route: {
              name: 'products.index',
              query: {
                filter: 'pastMonth',
              },
            },
          },
          {
            title: this.$t('static.products.filters.all'),
            route: {
              name: 'products.index',
            },
          },
        ],
        button: {
          title: `+ ${this.$t('static.products.create.title')}`,
          route: {
            name: 'products.create',
          },
        },
      },
      {
        title: this.$t('static.productGroups.filters.title'),
        options: [
          {
            title: this.$t('static.productGroups.filters.latest'),
            route: {
              name: 'productGroups.index',
              query: {
                filter: 'latest',
              },
            },
          },
          {
            title: this.$t('static.productGroups.filters.pastMonth'),
            route: {
              name: 'productGroups.index',
              query: {
                filter: 'pastMonth',
              },
            },
          },
          {
            title: this.$t('static.productGroups.filters.all'),
            route: {
              name: 'productGroups.index',
            },
          },
        ],
        button: {
          title: `+ ${this.$t('static.productGroups.create.title')}`,
          route: {
            name: 'productGroups.create',
          },
        },
      },
      {
        title: this.$t('static.unitOfMeasure.filters.title'),
        options: [
          {
            title: this.$t('static.unitOfMeasure.filters.all'),
            route: {
              name: 'unitOfMeasure.index',
            },
          },
        ],
        button: {
          title: `+ ${this.$t('static.unitOfMeasure.create.title')}`,
          route: {
            name: 'unitOfMeasure.create',
          },
        },
      },
    ]);
    this.all(1, 50);
  },

  destroyed() {
    this.unsetInnerSidebar();
  },

  methods: {
    ...mapMutations({
      setInnerSidebar: 'SET_INNERSIDEBAR',
      unsetInnerSidebar: 'UNSET_INNERSIDEBAR',
    }),

    /**
     * Fetches paginated unitOfMeasure.
     *
     * @param  {int} page The page number.
     * @param  {int} limit The number of items displayed on a page.
     */
    all : debounce( function(page, limit) {
        this.loading = true;
        unitOfMeasureService.items({
          page,
          limit,
          search: this.getSearch(),
          filter: this.$route.query.filter,
        }).then(() => {
          this.loading = false;
        }).catch(() => {
          this.loadProductsing = false;
        });
    },800),

    /**
     * Go to edit view for unitOfMeasure.
     *
     * @param  {Object} unitOfMeasure The unitOfMeasure object.
     */
    editWarehouse(unitOfMeasure) {
      const name = 'unitOfMeasure.edit';
      this.$router.push({
        name,
        params: { id: unitOfMeasure.id },
      });
    },
  },
};



// WEBPACK FOOTER //
// ./src/app/pages/withNavigation/unitOfMeasure/index/index.js